<div
  class="nav-actions-row"
  [class.nav-actions-row--with-back]="showBack"
  *ngIf="hasFaceSearchPermission() || hasFaceComparePermission() || hasVideoScannerPermission()">
  <div class="nav-actions-left" *ngIf="showBack">
    <button
      type="button"
      class="back-btn"
      (click)="onBackClick()">
      <i class="bi bi-arrow-left" aria-hidden="true"></i>
      <span>Back</span>
    </button>
  </div>

  <div class="nav-tabs-container">
    <button
      type="button"
      class="nav-tab nav-tab-reverse"
      [class.active]="activeTab === 'reverse-search'"
      *ngIf="hasFaceSearchPermission()"
      (click)="navigate('reverse-search')">
      <i class="fas fa-search custom-icon"></i>
      <span>Face Search</span>
    </button>
    <button
      type="button"
      class="nav-tab nav-tab-compare"
      [class.active]="activeTab === 'face-compare'"
      *ngIf="hasFaceComparePermission()"
      (click)="navigate('face-compare')">
      <i class="fas fa-people-arrows custom-icon"></i>
      <span>Face Compare</span>
    </button>
    <button
      type="button"
      class="nav-tab nav-tab-video"
      *ngIf="hasVideoScannerPermission()"
      [class.active]="activeTab === 'video-scanner'"
      (click)="navigate('video-scanner')">
      <i class="fas fa-video custom-icon"></i>
      <span>Video Scanner</span>
    </button>
  </div>

  <div class="nav-actions-right">
    <ng-content></ng-content>
  </div>
</div>
